const encode = encodeURIComponent;

export default (requests, axios) => {
    return {
        getAllFlags: () => {
            return requests.get('/country_flags.json');
        }
    }
};
